import { BooleanValue, Schema, StringValue } from '@coveo/bueno';
import { searchBoxOptionDefinitions, } from '../search-box/headless-search-box-options.js';
export const standaloneSearchBoxSchema = new Schema({
    ...searchBoxOptionDefinitions,
    redirectionUrl: new StringValue({
        required: true,
        emptyAllowed: false,
    }),
    overwrite: new BooleanValue({
        required: false,
    }),
});
